import { SORTING_DIRECTION } from 'src/constants/main';
import { TBooleanInNumber, TTranslate } from 'src/types/main';
import { BRANCH_DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { DELIVERY_ORDER_TYPE, IProductV4Modifier, IProductV4Size, PRODUCT_TYPE } from 'src/types/product';

export interface IMenuGroupsFilters {
  search: string;
  sortField: MENU_GROUPS_COLUMN_NAME | null;
  sortDir: SORTING_DIRECTION | null;
}

export enum MENU_GROUPS_COLUMN_NAME {
  NAME = 'name',
  CATEGORIES_COUNT = 'categories',
  ITEMS_COUNT = 'items',
}

export interface IMenuGroup {
  id: number;
  name: TTranslate;
  delivery_type: BRANCH_DELIVERY_TYPE;
  categories_count: number;
  items_count: number;
  sort: number;
  created_at: string | number;
  external_id: number | null;
  categories: IMenuGroupCategory[];
}

export interface IMenuGroupCategory {
  id: number;
  name: TTranslate;
  status: TBooleanInNumber;
  menu_group_sort?: number;
  items: IMenuGroupProduct[];
}

export interface IMenuGroupProduct {
  id: number;
  name: TTranslate;
  image: string;
  price: string;
  out_of_stock: TBooleanInNumber;
  status: TBooleanInNumber;
  category?: {
    id: number;
    name: TTranslate;
  };
  type?: PRODUCT_TYPE;
  order_type: DELIVERY_ORDER_TYPE;
  menu_group_sort?: number;
  menu_group_price?: string;
  vat: number;
  is_size: boolean;
  sizes: IProductV4Size[];
  modifiers: IProductV4Modifier[];
  is_donation: number;
}
